import { addItemToCollection } from "directus/src/operations";

export async function createCurrency({ item }) {
  try {
    const data = await addItemToCollection("currencies", item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
